import "../styles/global.css";
import "../styles/scss/index.scss";
import { Provider } from "react-redux";
import { useStore } from "../redux/store/index";
import { MonitoringErrorBoundary } from "@/src/components/error-handling/MonitoringErrorBoundary";

import type { AppProps } from "next/app";

const BRIBrain = ({ Component, pageProps }: AppProps) => {
  const store = useStore(pageProps.initialReduxState);

  return (
    <MonitoringErrorBoundary componentName="App">
      <Provider store={store}>
        <Component {...pageProps} />
      </Provider>
    </MonitoringErrorBoundary>
  );
};
export default BRIBrain;
